import React from 'react';
import {
  Button,
  FluidButtonLayout,
  Form,
  Gutter,
  ReadonlyTextarea,
  Textarea,
} from '@axiom/ui';
import type { Position } from '@axiom/validation';

import { PositionsLegacyApi } from '../../api/positions-legacy-api';
import { OpportunityStore } from '../../stores/opportunity-store';
import { OpportunityLegacyApi } from '../../api/opportunity-legacy-api';

import { OpportunityProfilePositionsDescriptionFormSchema } from './opportunity-profile-positions-description-form-schema';

export type OpportunityProfilePositionsDescriptionFormProps = {
  position: Position;
  isEditPositionDescriptionOpen: boolean;
  onClose: () => void;
};

export const OpportunityProfilePositionsDescriptionForm = ({
  position,
  isEditPositionDescriptionOpen,
  onClose,
}: OpportunityProfilePositionsDescriptionFormProps) => {
  return (
    <Form
      name="OPPORTUNITY_PROFILE_POSITIONS_DESCRIPTION_FORM"
      schema={OpportunityProfilePositionsDescriptionFormSchema}
      initialValues={{ description: position.description }}
      onSubmit={async formData => {
        await PositionsLegacyApi.updatePosition(position.id, {
          id: position.id,
          description: formData.description,
        });

        // expect opportunityId to be here, but since type is possibly null, it needs to be checked
        if (position.opportunityId) {
          await OpportunityStore.load(position.opportunityId);
          await OpportunityLegacyApi.refreshOpportunity(position.opportunityId);
        }

        onClose();
      }}
    >
      {({ fireSubmit, values }) => {
        return isEditPositionDescriptionOpen ? (
          <>
            <Textarea
              name="description"
              full
              formatting="modern"
              enableSuggestionsFor="envoy-OpportunityProfilePositionsDescriptionForm-description"
            />
            <Gutter bottom="16px" />
            <FluidButtonLayout name="FORM_BUTTONS">
              <Button
                name="POSITION_DESCRIPTION_CANCEL"
                variation="outline"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button name="POSITION_DESCRIPTION_SAVE" onClick={fireSubmit}>
                Save
              </Button>
            </FluidButtonLayout>
          </>
        ) : (
          <ReadonlyTextarea
            name="READONLY_DESCRIPTION"
            value={values.description}
            formatting="modern"
          />
        );
      }}
    </Form>
  );
};
